import axios from 'axios';
import { getAccessToken, endSession } from '@/utils/authStorage';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
  headers: {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  },
  withCredentials: false
});

// Attach the login token (see utils/authStorage.js)
instance.interceptors.request.use(
  config => {
    const token = getAccessToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => Promise.reject(error)
);

// A 401 from the Identity Center means the login is no longer valid
// (expired or revoked). End the session so the user signs in again,
// instead of leaving every screen half-broken.
instance.interceptors.response.use(
  response => response,
  error => {
    const sentToken = !!error.config?.headers?.Authorization;
    if (error.response?.status === 401 && sentToken && !error.config?.skipAuthRedirect) {
      endSession();
    }
    return Promise.reject(error);
  }
);

export default instance;
